export enum SupplierState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',

  /**
   * A supplier that has been requested but not yet confirmed.
   * Behaves the same way as {@link Inactive}.
   */
  Requested = 'REQUESTED',
}
